/* eslint-disable import/no-unused-modules */

import useLiveSanityContent from "src/ssc-api/useLiveSanityContent";
import {
  SanityShorexData,
  SanityShorexSelectionCategoryItem,
  shorexContentQuery,
  shorexesSelectionQuery
} from "@silversea-ssc/system-components-react/ShorexDrawer/utils";

export const useSanityShorexSelection = (cruiseCode: string) => {
  const { status, data } = useLiveSanityContent<
    SanityShorexSelectionCategoryItem[]
  >(shorexesSelectionQuery, {
    $cruiseCode: cruiseCode
  });

  return { status, data: data?.result || [] };
};

export const useShorexContent = (shorexWebCode: string) => {
  return useLiveSanityContent<SanityShorexData>(shorexContentQuery, {
    $shorexWebCode: shorexWebCode
  });
};
